
import { getLastCaption } from './Caption';
import { InterceptMiddle } from '../../regular';
/**
 * 判断单选试题条件是否成立
 * @param condition 条件
 * @param list 试题list
 * @return Boolean
 */
export const IsDefaultEligible = (list, newCondition, condition, text) => {
    let result = false
    let reg = /(\==|>|>=|<|<=)(.+?)(?=\])/ig
    
    let code = InterceptMiddle(condition, ['['], ['==', '>', '>=', '<', '<=', '_', ':'])
    code = code ? code : undefined
    let sonOrderNum = InterceptMiddle(condition, ['_'], [']', '=='])
    sonOrderNum = sonOrderNum ? sonOrderNum : undefined
    let orderNum = getLastCaption(newCondition, 1, '=') // 选项序号
    list.forEach(info => {
        // console.log('code == info.quesCode, info.bindIsShow, info.isShow :>> ', code == info.quesCode, info.bindIsShow, info.isShow);
        if (code == info.quesCode && info.bindIsShow && info.isShow) {
            // console.log('info.questionsTypeId :>> ', info.questionsTypeId);
            switch(info.questionsTypeId) {
                case '6': // 图片选择
                case '8': // 单选
                case '12': // 判断
                    info.optionList.forEach(op => {
                        // console.log(orderNum, op.orderNum, orderNum == op.orderNum)
                        // console.log(info.userAnswer, op.oid, info.userAnswer == op.oid)
                        if (orderNum == op.orderNum && info.userAnswer == op.oid) {
                            // console.warn('到了')
                            result = true
                        }
                    })
                    break
                
                case '10': // 多选
                    info.optionList.forEach(op => {
                        if (orderNum == op.orderNum && info.userAnswerArr.indexOf(op.oid) != -1) {
                            result = true
                        }
                    })
                    break
                case '11': //星级
                case '38': //量表
                    let value = condition.match(reg) ? condition.match(reg)[0] : condition.match(reg)
                    result = eval(info.userAnswer + value)
                    break
                case '19': // 矩阵单选
                    info.questionsSonList.forEach(son => {
                        if (sonOrderNum == son.orderNum) {
                            son.optionList.forEach(op => {
                                let i = info.userAnswerArr.findIndex((info) =>{
                                    if (info.value.indexOf(op.oid) != -1 && son.SonId == info.SonId){
                                        return true
                                    }
                                })
                                if (orderNum == op.orderNum && i != -1) {
                                    result = true
                                }
                            })
                        }
                    })
                    break
                case '21': // 矩阵星级
                    let optionValue = condition.match(reg) ? condition.match(reg)[0] : condition.match(reg)
                    orderNum = InterceptMiddle(sonOrderNum, ['_'], ['==', '>', '>=', '<', '<='])
                    sonOrderNum = InterceptMiddle(sonOrderNum, [], ['_'])
                    info.questionsSonList.forEach(son => {
                        if (sonOrderNum == son.orderNum) {
                            son.optionList.forEach(op => {
                                info.userAnswerArr.forEach((info) =>{
                                    if (son.SonId == info.SonId) {
                                        info.optionValue.forEach((o) => {
                                            if (orderNum == op.orderNum && o.oid == op.oid && 
                                                eval(o.value + optionValue)
                                            ) {
                                                result = true
                                            }
                                        })
                                    }
                                })
                            })
                        }
                    })
                    break
                case '22': // 矩阵填空
                case '39': // 矩阵组合
                // console.log('condition :>> ', condition);
                    let oValue = InterceptMiddle(condition, ['=='], [']'])
                    orderNum = InterceptMiddle(sonOrderNum, ['_'], ['=='])
                    sonOrderNum = InterceptMiddle(sonOrderNum, [], ['_'])
                    // console.log('sonOrderNum,orderNum,oValue, :>> ', sonOrderNum,orderNum,oValue);
                    info.questionsSonList.forEach(son => {
                        if (sonOrderNum == son.orderNum) {
                            son.optionList.forEach(op => {
                                // console.log('info.userAnswerArr :>> ', info.userAnswerArr);
                                info.userAnswerArr.forEach((info) =>{
                                    if (son.SonId == info.SonId) {
                                        info.optionValue.forEach((o) => {
                                            // console.log('o.value, oValue :>> ', o.value, oValue);
                                            // console.log('orderNum , op.orderNum :>> ', orderNum , op.orderNum);
                                            // console.log('orderNum == op.orderNum, o.oid == op.oid, o.value == oValue :>> ', orderNum == op.orderNum, o.oid == op.oid, o.value == oValue);
                                            if (orderNum == op.orderNum && o.oid == op.oid && 
                                                o.value == oValue
                                            ) {
                                                result = true
                                            }
                                        })
                                    }
                                })
                            })
                        }
                    })
                    break
            }
        }
        // else if (code == info.quesCode && !info.bindIsShow && !info.isShow){
        //     result = true
        // }
    })
    return result;
}